import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IMoneyDto } from "../../rma-types";
import RmaNotZeroMoneyAmount from "../rma-not-zero-money-amount/rma-not-zero-money-amount";

interface IProps {
    exchangeRangeAdjustmentMoneyDto: IMoneyDto;
    color?: FONT_COLOR;
    amountFontVariant?: FONT_VARIANT | FONT_VARIANT[];
    useColon?: boolean;
}

const ItemBalanceExchangeRangeAdjustment: React.FC<IProps> = ({ 
    exchangeRangeAdjustmentMoneyDto, 
    color,
    amountFontVariant,
    useColon,
}) => {
    const rmaCardScope = 'dashboard-returns-rma-card';
    const { getTranslation } = useDashboardTranslation();

    if (exchangeRangeAdjustmentMoneyDto.amount === 0) {
        return null;
    }
    
    const title = exchangeRangeAdjustmentMoneyDto.amount > 0 ? getTranslation('FREE_EXCHANHGE_RANGE_BONUS', rmaCardScope) : getTranslation('FREE_EXCHANHGE_RANGE_FEE', rmaCardScope);
    return (
        <RmaNotZeroMoneyAmount
            title={title}
            moneyDto={exchangeRangeAdjustmentMoneyDto}
            color={color}
            amountFontVariant={amountFontVariant}
            useColon={useColon}
            subItem={true}
        />
    );
}

export default ItemBalanceExchangeRangeAdjustment;

